module.exports = __webpack_public_path__ + "static/img/down_img01.png.78a0f84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sptj/down_img01.png.png
// module id = 8fdh
// module chunks = 1